module.exports = __webpack_public_path__ + "static/media/video-14-tt.a5c42947.webm";